import AllDropdownItem from "../../../table-actions-panel/models/selection-dropdown-item/AllDropdownItem/AllDropdownItem";

export default class AllWebsitesSelectionItem extends AllDropdownItem {
    getSelectedTranslation() {
        return {
            key: "si.table-actions-panel.options.websites.all.selected",
            replacements: {
                numberOfItems: this.formatValue(),
            },
        };
    }
}
